import { useState } from 'react'
import { CursorArrowIcon, MoveIcon, RotateCounterClockwiseIcon, TransformIcon, PlusIcon } from '@radix-ui/react-icons'
import Icon from '@mdi/react'
import { mdiCube, mdiCylinder, mdiSphere, mdiRectangle, mdiTriangle } from '@mdi/js'

export type Tool = 'select' | 'move' | 'rotate' | 'scale' | 'add'
export type Primitive = 'cube' | 'cylinder' | 'sphere' | 'plane' | 'cone'

interface ToolbarProps {
  selectedTool: Tool
  onToolSelect: (tool: Tool) => void
  onPrimitiveAdd: (primitive: Primitive) => void
}

export function Toolbar({ selectedTool, onToolSelect, onPrimitiveAdd }: ToolbarProps) {
  const [showAddMenu, setShowAddMenu] = useState(false)

  const handleToolClick = (tool: Tool) => {
    if (tool === 'add') {
      setShowAddMenu(!showAddMenu)
    } else {
      setShowAddMenu(false)
    }
    onToolSelect(tool)
  }

  const handlePrimitiveSelect = (primitive: Primitive) => {
    onPrimitiveAdd(primitive)
    setShowAddMenu(false)
  }

  const toolButtons = [
    { tool: 'select' as Tool, icon: CursorArrowIcon, title: 'Select (1)' },
    { tool: 'move' as Tool, icon: MoveIcon, title: 'Move (2)' },
    { tool: 'rotate' as Tool, icon: RotateCounterClockwiseIcon, title: 'Rotate (3)' },
    { tool: 'scale' as Tool, icon: TransformIcon, title: 'Scale (4)' },
    { tool: 'add' as Tool, icon: PlusIcon, title: 'Add Object' },
  ]

  const primitives = [
    { type: 'cube' as Primitive, icon: mdiCube, title: 'Cube' },
    { type: 'cylinder' as Primitive, icon: mdiCylinder, title: 'Cylinder' },
    { type: 'cone' as Primitive, icon: mdiTriangle, title: 'Cone' },
    { type: 'sphere' as Primitive, icon: mdiSphere, title: 'Sphere' },
    { type: 'plane' as Primitive, icon: mdiRectangle, title: 'Plane' },
  ]

  return (
    <div className="toolbar">
      <div className="toolbar-main">
        {toolButtons.map(({ tool, icon: IconComponent, title }) => (
          <button
            key={tool}
            className={`toolbar-button ${selectedTool === tool ? 'active' : ''}`}
            onClick={() => handleToolClick(tool)}
            title={title}
            aria-label={title}
            aria-pressed={selectedTool === tool}
          >
            <IconComponent className="toolbar-icon" />
          </button>
        ))}
      </div>
      
      {showAddMenu && (
        <div className="add-menu">
          {primitives.map(({ type, icon, title }) => (
            <button
              key={type}
              className="add-menu-button"
              onClick={() => handlePrimitiveSelect(type)}
              title={title}
              aria-label={`Add ${title.toLowerCase()}`}
            >
              <Icon path={icon} size={0.8} />
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
